module.exports = __webpack_public_path__ + "img/image3.037ad179.png";